// extracted by mini-css-extract-plugin
export default {"root":"RolesManagement_root__CvvGb"};